import { Provider } from '@angular/core';

import { StaticTextRepositoryImpl } from '@app/data/repositories/static-text/static-text.repository';
import { STATIC_TEXT_REPOSITORY } from '@app/domain/repositories/static-text/static-text.repository.contract';

export const staticTextRepositoryProvider: Provider = {
  provide: STATIC_TEXT_REPOSITORY,
  useClass: StaticTextRepositoryImpl
};
